import React, { useState, useEffect } from 'react';
import { libraryAPI } from '../../../../services/library.service';
import BookList from './BookList';
import BookForm from './BookForm';
import CategoryModal from '../CategoryManager/CategoryModal';
// Note: We'll likely need to access other managers' modals or have shared modals.
// For now, I'll allow opening shared modals via props from AdminPanel if needed, or better, implement them here or import them.
// The original AdminPanel had all modals in one place.
// I will import CategoryModal and AuthorForm locally if I can.

const LibraryManager = ({ showMessage, openAuthorModal, openCategoryModal }) => {
  const [booksList, setBooksList] = useState([]);
  const [categories, setCategories] = useState([]);
  const [authors, setAuthors] = useState([]);
  const [view, setView] = useState('list'); // 'list' or 'form'
  const [editingItem, setEditingItem] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      const [booksResponse, catsResponse, authorsResponse] = await Promise.all([
        libraryAPI.getBooks(),
        libraryAPI.getCategories(),
        libraryAPI.getAuthors()
      ]);
      
      setBooksList(booksResponse.data?.results || booksResponse.data || []);
      setCategories(catsResponse.data?.results || catsResponse.data || []);
      setAuthors(authorsResponse.data?.results || authorsResponse.data || []);
    } catch (error) {
      console.error('Ошибка загрузки библиотеки:', error);
      if(showMessage) showMessage('Ошибка загрузки данных библиотеки', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (formData) => {
    setLoading(true);
    try {
      const data = new FormData();
      Object.keys(formData).forEach(key => {
        if (key === 'authors' || key === 'categories') {
          // Обработка массивов для FormData
          formData[key].forEach(id => data.append(key, id));
        } else if (formData[key] !== null) {
          data.append(key, formData[key]);
        }
      });

      if (editingItem) {
        await libraryAPI.updateBook(editingItem.slug, data);
        if(showMessage) showMessage('Книга обновлена!');
      } else {
        await libraryAPI.createBook(data);
        if(showMessage) showMessage('Книга добавлена!');
      }
      
      setView('list');
      setEditingItem(null);
      loadData();
    } catch (error) {
      console.error('Ошибка сохранения:', error);
      if(showMessage) showMessage('Ошибка сохранения книги', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (slug) => {
    if (!window.confirm('Вы уверены, что хотите удалить эту книгу?')) return;
    try {
      await libraryAPI.deleteBook(slug);
      if(showMessage) showMessage('Книга удалена');
      loadData();
    } catch (error) {
      console.error('Ошибка удаления:', error);
      if(showMessage) showMessage('Ошибка удалении книги', 'error');
    }
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setView('form');
  };

  return (
    <div className="admin-content">
      <div className="content-header">
        <h2>{view === 'list' ? 'Управление библиотекой' : (editingItem ? 'Редактировать книгу' : 'Добавить книгу')}</h2>
        <button
          className={`action-button ${view === 'form' ? 'secondary' : 'primary'}`}
          onClick={() => {
            if (view === 'form') {
              setView('list');
              setEditingItem(null);
            } else {
              setView('form');
              setEditingItem(null);
            }
          }}
        >
          {view === 'list' ? '➕ Добавить книгу' : '📋 К списку'}
        </button>
      </div>

      {view === 'list' ? (
        <BookList 
          books={booksList} 
          onEdit={handleEdit} 
          onDelete={handleDelete} 
        />
      ) : (
        <BookForm 
          initialData={editingItem} 
          categories={categories}
          authors={authors}
          onSubmit={handleSubmit} 
          onCancel={() => { setView('list'); setEditingItem(null); }}
          onAddAuthor={openAuthorModal}
          onAddCategory={openCategoryModal}
          loading={loading}
        />
      )}
    </div>
  );
};

export default LibraryManager;
